import { useEffect } from "react";
import { supabase } from "../lib/supabase";

const TRAFFIC_TRACKED_KEY = "bizwell_traffic_tracked";
const VISITOR_ID_KEY = "bizwell_visitor_id";

const BOT_PATTERNS = [
  /bot/i, /crawler/i, /spider/i, /scrape/i, /lighthouse/i,
  /pingdom/i, /googlebot/i, /bingbot/i, /yandex/i, /baidu/i,
  /facebookexternalhit/i, /twitterbot/i, /linkedinbot/i,
  /headless/i, /phantom/i, /selenium/i, /puppeteer/i,
  /ahrefs/i, /semrush/i, /moz/i,
];

function isBot(): boolean {
  const ua = navigator.userAgent;
  return BOT_PATTERNS.some((p) => p.test(ua));
}

function getVisitorId(): string {
  const existing = localStorage.getItem(VISITOR_ID_KEY);
  if (existing) return existing;
  const id = `v_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
  localStorage.setItem(VISITOR_ID_KEY, id);
  return id;
}

function isNewVisitor(): boolean {
  return !localStorage.getItem(VISITOR_ID_KEY);
}

async function trackTraffic() {
  if (isBot()) return;
  if (sessionStorage.getItem(TRAFFIC_TRACKED_KEY)) return;

  const isUnique = isNewVisitor();
  getVisitorId(); // ensure created

  try {
    const { error } = await supabase.rpc("increment_traffic", {
      is_unique: isUnique,
    });
    if (error) {
      console.error("Traffic tracking error:", error);
      return;
    }
    sessionStorage.setItem(TRAFFIC_TRACKED_KEY, "1");
  } catch (err) {
    console.error("Traffic tracking failed:", err);
  }
}

export function useTrafficTracking() {
  useEffect(() => {
    trackTraffic();
  }, []);
}

export default useTrafficTracking;